import { MODULE_PREFIX } from '../constants';

export default {
    FETCH_AUDIT: `${MODULE_PREFIX}/FETCH_AUDIT`,
    FETCH_AUDIT_SUCCESS: `${MODULE_PREFIX}/FETCH_AUDIT_SUCCESS`,
    FETCH_AUDIT_FAILURE: `${MODULE_PREFIX}/FETCH_AUDIT_FAILURE`,
};
